import { type Table } from "@tanstack/react-table";
import { Button } from "@/components/ui/Button";
import { FaFileCsv } from "react-icons/fa";
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/DropdownMenu";

interface DataTableViewOptionsProps<TData, TValue> {
  action?: () => void;
  table?: Table<TData>;
}

export function DataTableViewOptions<TData, TValue>({
  action = () => null,
  table
}: DataTableViewOptionsProps<TData, TValue>) {
  function handleClick() {
    action();
  }



  return (
    <div className="flex justify-between items-center gap-2 sm:gap-3">
      <Button
        className="bg-primary text-xs sm:text-sm md:text-base text-gray-400  flex items-center gap-1 h-8 sm:h-8 md:h-8"
        onClick={handleClick}
      >
        <FaFileCsv className="size-3 sm:size-4 md:size-5 text-white " />
        {/* <span className="hidden sm:inline">Export CSV</span>
        <span className="sm:hidden">CSV</span> */}
      </Button>

      {table && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              className="w-fit h-8 text-xs lg:text-base text-gray-400 "
            >
              <i className="fa fa-gear pr-1"></i>
              Table Settings
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="w-fit max-h-56 custom-scrollbar"
          >
            {table
              .getAllColumns()
              .filter(
                (column) =>
                  typeof column.accessorFn !== "undefined" &&
                  column.getCanHide() &&
                  ![
                    "ticket_id",
                    "customer_name",
                    "customer_email",
                    "service",
                    "counter",
                    "status",
                    "contact_number",
                  ].includes(column.id) // Exclude specific columns
              )
              .map((column) => {
                const { meta }: any = column.columnDef;
                return (
                  <DropdownMenuCheckboxItem
                    key={column.id}
                    className="capitalize"
                    onSelect={(event) => event.preventDefault()} // Prevent dropdown from closing
                    checked={column.getIsVisible()}
                    onCheckedChange={(value) =>
                      column.toggleVisibility(!!value)
                    }
                  >
                    {(meta as string) ?? column.id}
                  </DropdownMenuCheckboxItem>
                );
              })}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
